import { Box, Button, CircularProgress, Collapse, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"
import { PartnerService } from "../../../services/partner"
import { Format } from "../../../utils"
import useAuth from "../../../context/auth"
import moment from "moment"
import { useNavigate } from "react-router-dom"

export interface IMovements {
    id: number
    createdAt: string
    value: number
    balanceAfter: number
    balanceBefore: number
    event: number
    description: string
    extraData?: {
        client?: {
            id: number
            name: string
            cpf: string
            cnpj: string
        }
    }
}

export const PartnerExtract = () => {
    const { user, isMobile } = useAuth()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [movements, setMovements] = useState<IMovements[]>([])

    const getMovements = () => {
        setLoading(true)
        PartnerService.getMovements(user?.account?.id as number)
            .then(({ data }) => {
                setMovements(data?.movements?.rows)
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        getMovements()
    }, [])

    return (
        <Box
            sx={{
                maxWidth: "150rem",
                width: "100%",
                margin: "0 auto",
                ...(!isMobile && {
                    padding: "0 2rem",
                    boxSizing: "border-box"
                }),
            }}
        >
            <Typography fontSize={"2rem"} fontWeight={600} mb={"1rem"}>Extrato</Typography>

            <Collapse in={movements?.length > 0}>
                <Grid
                    display={"flex"}
                    direction={"column"}
                    gap={"1.5rem"}
                >
                    {movements.map((item) => {
                        let date = moment(item.createdAt).format("DD/MM/YYYY")
                        if (moment().isSame(item.createdAt, "date")) date = "Hoje"
                        if (moment().subtract(1, "day").isSame(item.createdAt, "date")) date = "Ontem"
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                gap={".5rem"}
                                justifyContent={"space-between"}
                                padding={"2rem 1rem"}
                                boxSizing={"border-box"}
                                width={"100%"}
                                sx={{
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "10px"
                                }}
                            >
                                <Grid
                                    display={"flex"}
                                    flexDirection={"row"}
                                    alignItems={"flex-start"}
                                    gap={".7rem"}
                                >

                                    <Grid
                                        display={"flex"}
                                        flexDirection={"column"}
                                        gap={".5rem"}
                                    >
                                        <Typography fontSize={"1.6rem"} fontWeight={600}>{item.description}</Typography>
                                        <Typography fontSize={"1.6rem"} lineHeight={"1.9rem"} sx={{ opacity: .5 }}>Data: {date}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid
                                    display={"flex"}
                                    flexDirection={"column"}
                                    alignItems={"flex-end"}
                                    justifyContent={"flex-start"}
                                >
                                    <Typography fontSize={"2rem"} textAlign={"right"} fontWeight={600} color={item.value >= 0 ? "#49B84F" : "#DA1717E5"} lineHeight={"2.4rem"}>{Format.currency(item.value > 0 ? item.value : item.value * -1)}</Typography>
                                </Grid>
                            </Box>
                        )
                    })}
                </Grid>
            </Collapse>

            {loading && <Grid display={"flex"} alignContent={"center"} justifyContent={"center"} mt={"2rem"} mb={"2rem"}><CircularProgress size={30} /></Grid>}

            {(movements?.length === 0 && !loading) &&
                <Typography textAlign={"center"} sx={{ opacity: .5 }} mt={"2rem"}>Nenhuma movimentação encontrada...</Typography>
            }

            <Grid
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Button
                    sx={{
                        height: "4rem",
                        mt: "2rem",
                        maxWidth: "80rem",
                        width: "100%",  // Garante que o botão ocupe toda a largura disponível até o valor máximo
                        margin: "3rem auto",  // Centraliza horizontalmente
                        display: "flex",
                    }}
                    variant="outlined"
                    onClick={() => navigate(-1)}
                >Voltar</Button>
            </Grid >
        </Box>
    )
}